import React from 'react';
import cn from 'classnames';
import {StandardProps} from '.';

export type CardActionsProps = StandardProps;

export const CardActions: React.FC<CardActionsProps> = ({className, ...restProps}) => {
  return <div className={cn('card-actions', className)} {...restProps} />;
};

export default CardActions;
